import { useGetMappingConsignmentsQuery, type ConsignmentListType } from '@/entities/dashboard/mapping';
import { useProjectSiteParams } from '@/shared/lib';

import type { MapDataFilters } from './map-provider.interface';

interface UseClusterConsignmentsParams {
  locationIds: string[];
  type: ConsignmentListType;
  /** Weeks back the time machine is showing; 0 is the present. */
  weeksAgo: number;
  dataFilters?: MapDataFilters;
}

/**
 * The consignments adding up to one marker slice — legacy's table behind the Cargo
 * Awaiting Collection, Stock Available to Dispatch and Expected Cargo Deliveries
 * slices (`mapping.js:175-206`). Released cargo has no such list; it opens the pie.
 */
export function useClusterConsignments({ locationIds, type, weeksAgo, dataFilters }: UseClusterConsignmentsParams) {
  const { projectId, siteId } = useProjectSiteParams();

  const { data, isFetching } = useGetMappingConsignmentsQuery({
    locationIds,
    type,
    weekNo: weeksAgo || undefined,
    projectId,
    siteId,
    organizationId: dataFilters?.organizationId,
    consignmentNumber: dataFilters?.consignmentNumber
  });

  return { consignments: data?.consignments ?? [], isLoading: isFetching };
}
